import PresentationApi from '@/api/presentation'
import Socket from '@/socket'
import router from '@/router'
import Utils from '@/util'
import gaCategories from '@/constant/gaCategories'
import Constant from '@/constant'

const setPresentationAction = ({ commit }, presentation) => {
  commit('setPresentation', presentation)
}

const createNewPresentationAction = async (
  {
    state, dispatch, commit, getters,
  },
  { trigger, onSuccess, onFailure },
) => {
  const { selectedFolderId } = state.selections
  const {
    currentUser, currentAccount, workingMode, presentations,
  } = state
  commit('setIsCreatingNewPresentation', true)
  try {
    const newPresentation = await PresentationApi.createNewPresentation({
      name: Constant.presentation.defaultPresentationName,
      accessCode: '',
      socketId: Socket.getSocketId(),
      folderId: selectedFolderId,
      hasDefaultSlide: true,
      fromWorkspace: workingMode === 'team',
    })
    newPresentation.User = currentUser
    router.push({
      name: 'PresentationDetail',
      params: { id: newPresentation.id },
      query: {
        new: true,
      },
    })
    const teamId = workingMode === 'team' ? currentAccount.id : null
    const isTeamPresentation = workingMode === 'team'
    const isSelfCreatedTeam = currentAccount.createdFrom === 'presenter'
    Utils.gaTrackEvent(
      gaCategories.PRESENTATION_LIST,
      'Create new presentation',
      trigger,
      null,
      {
        presentationId: newPresentation.id,
        isSelfCreatedTeam,
        teamId,
        isTeamPresentation,
      },
    )

    if (getters.abTestGroup === 2 || getters.abTestGroup === 3) {
      Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Create new slide', null, null, {
        isDefaultSlide: true,
      })
    }
    dispatch('setPresentationsAction', [...presentations, newPresentation])
    if (onSuccess) {
      onSuccess(newPresentation)
    }
  } catch (e) {
    commit('setIsCreatingNewPresentation', false)
    if (onFailure) {
      onFailure(e)
    }
  }
}

const setMorePresentationsLoadingAction = ({ commit }, payload) => {
  commit('setMorePresentationsLoading', payload)
}

const patchPresentationAction = ({ commit, state, dispatch }, partialPresentation) => {
  commit('setPresentation', { ...state.presentation, ...partialPresentation })

  // Whenever update reportUrl, dispatch the action to get the report data
  if (partialPresentation.exportData && partialPresentation.exportData.reportUrl) {
    dispatch('presentationReport/getPresentationReport', partialPresentation)
  }
}

export default {
  // use action which has suffix 'Action'
  setPresentationAction,
  setPresentation: setPresentationAction,
  createNewPresentationAction,
  patchPresentationAction,
  updatePresentation: patchPresentationAction,
  setMorePresentationsLoadingAction,
}
